import { Controller } from "@hotwired/stimulus";
import { isFlatpickrInput, flatpickrAltInput } from "../utils/date_utils";

export default class extends Controller {
  static targets = ["field", "icon"];

  connect() {
    requestAnimationFrame(() => {
      const input = isFlatpickrInput(this.fieldTarget) ? flatpickrAltInput(this.fieldTarget) : this.fieldTarget;

      this.parsley = $(input).parsley();

      this.parsley.on("field:error", this.showError);
      this.parsley.on("field:success", this.clearError);
    });
  }

  showError = () => {
    const messages = this.parsley.getErrorsMessages();
    const content = messages.join("<br><div class='line-separator margin-bottom_5px'></div>");

    this.iconTarget.setAttribute("data-original-title", content);
    this.iconTarget.classList.remove("hidden");
  };

  clearError = () => {
    this.iconTarget.classList.add("hidden");
  };
}
